import {getEmail, getPw, getToken, login, storeToken} from "./ForAuth";
import {apiUrl} from "./apiUrl";

export const hide = (id) => {
    document.getElementById(id).classList.toggle('hidden');
}

export const isJson = (str) => {
    if (typeof str == 'object') return true;
    try {
        JSON.parse(str)
    } catch(err) {
        return false;
    }
    return true;
}

export const isEnglish = (str) => /^[a-zA-Z_\s]*$/.test(str)

export async function wrappedFetch(url, options = {}, api = apiUrl) {
    const apis = api+url
    const token = getToken();

    const defaultHeaders = {
        'Content-Type': 'application/json',
        'Authorization': token ? token : '', // 토큰이 있으면 헤더에 추가
    };

    const mergedOptions = {
        ...options,
        headers: {
            ...defaultHeaders,
        },
    };

    if (options.headers) {
        mergedOptions.headers = {
            ...defaultHeaders,
            ...options.headers,
        };
    }

    const response = await fetch(apis, mergedOptions);

    if (response.ok) {
        return response;
    }
    await login(getEmail(), getPw())
        .then(json =>{
            storeToken(json.token)
            mergedOptions.headers['Authorization'] = json.token;
        })
    const res = await fetch(apis, mergedOptions);
    return res
}

export const filter = (array, search)=>{
    if (!Array.isArray(array)) return array;
    if (search === '') return array;
    return array.filter(it => Object.values(it).some(i=> {
        if (typeof i === 'string') return i.includes(search)
        else if (typeof i === 'number') return i.toString().includes(search);
        else return false;
    }))
}
